

import { email, required, minLength } from "vuelidate/lib/validators";
import "@/plugins/vuelidate"

export default {

  data() {
    return {
      val: false,
      showModal: false,
      formLogin: {
        name: "",
        email: "",
      },
    };
  },
  validations: {
    formLogin: {
      name: { required, minLength: minLength(2) },
      email: { email, required },
    },
  },
  methods: {
    sendData() {
      this.val = true
      this.$v.$touch();
      if (!this.formLogin.name || !this.formLogin.email) {
        return;
      }

      this.$axios.post('/api/newsletter/subscribe', {
        name: this.formLogin.name,
        email: this.formLogin.email,

      })
        .then(function (response) {
        })
        .catch(function (error) {
          console.log(error);
        });


      this.formLogin.name = "";
      this.formLogin.email = "";

      this.val = false;

      this.showModal = true;
      setTimeout(() => this.showModal = false, 4000)

    },
  },
};
